import type { SeoConfig } from '@shopify/hydrogen';
import { data } from 'react-router';
import { LOGIN_PATH, STOREFRONT_REDIRECT_PATH } from '~/constants';
import { countries } from '~/data/countries';
import type { ActionData, I18nLocale } from '~/types';

export const isClient = () => typeof window !== 'undefined';

export const INPUT_STYLE_CLASSES =
  'appearance-none rounded dark:bg-transparent border focus:border-primary/50 focus:ring-0 w-full py-2 px-3 text-primary/90 placeholder:text-primary/50 leading-tight focus:shadow-outline';

export const getInputStyleClasses = (isError?: string | null) => {
  return `${INPUT_STYLE_CLASSES} ${isError ? 'border-red-500' : 'border-primary/20'}`;
};

export function getLocaleFromRequest(request: Request): I18nLocale {
  const url = new URL(request.url);
  const firstPathPart = '/' + url.pathname.substring(1).split('/')[0].toLowerCase();

  return countries[firstPathPart]
    ? {
        ...countries[firstPathPart],
        pathPrefix: firstPathPart,
      }
    : {
        ...countries.default,
        pathPrefix: '',
      };
}

/**
 * Validates that a url is local
 * @param url the url string to validate
 * @returns `true` if local `false`if external domain
 */
export function isLocalPath(url: string) {
  try {
    // We don't want to redirect cross domain,
    // doing so could create fishing vulnerability
    // If `new URL()` succeeds, it's a fully qualified
    // url which is cross domain. If it fails, it's just
    // a path, which will be the current domain.
    new URL(url);
  } catch {
    return true;
  }

  return false;
}

export const badRequest = (payload: ActionData) => data(payload, { status: 400 });

export function getStorefrontRedirectUrl(customerAccountApiUrl: string, page?: string | null) {
  const returnTo = page ? `?return_to=${page}` : '';

  return customerAccountApiUrl + STOREFRONT_REDIRECT_PATH + returnTo;
}

type SeoDataObj = Record<string, unknown> & { seo: SeoConfig };
export const hasSeoData = (data: unknown): data is SeoDataObj => {
  return !!data && typeof data === 'object' && 'seo' in data;
};

/** Add random query string to login route to prevent browser reading from cache */
export const loginPath = () => `${LOGIN_PATH}?z=${Math.random()}`;
